import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=56ed15db&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ed15db')) {
      api.createRecord('56ed15db', component.options)
    } else {
      api.reload('56ed15db', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=56ed15db&", function () {
      api.rerender('56ed15db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Na7rLZPOiSnK/JS/pricehelp.vue"
export default component.exports